import React from "react";
import styled from "styled-components";
import I10n from "../../../features/i10n";
import MsxIcons from "../../msx-icons";
import Button from "../../../atoms/button";
import ReactSelect from "react-select";
import Checkbox from "../../../atoms/checkbox";
import { connect } from "react-redux";
import {
  massUpdateTerminalBlockSettings,
  updateTerminalBlockPreferences,
} from "../../configuration-management/ducks";
import { getCompatibleModules } from "../../get-modules/ducks";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  color: #333333;
  max-width: 100%;
  margin: auto;
  border-radius: 10px;

  @media all and (-ms-high-contrast: none) {
    margin: 0px;
    max-height: 100%;
  }

  se-tabbar .opt-content.tab-alternative nav {
    height: auto;
    a {
      flex: 1 1 0px;
    }
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  color: #43ce5d;
  color: var(--se-primary, #43ce5d);
  border-bottom: 2px solid #43ce5d;
  border-bottom: 2px solid var(--se-primary, #43ce5d);
  margin: 0px 20px;
  padding: 10px 0px;
`;

const Title = styled.span`
  font-weight: bold;
  font-size: 20px;
`;

const CloseIcon = styled.span`
  display: inline-block;
  color: #43ce5d;
  color: var(--se-primary, #43ce5d);
  cursor: pointer;
`;

const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
`;

const DropdownContainer = styled.div`
  margin-bottom: 20px;
`;

const SectionTitle = styled.h3`
  margin-bottom: 10px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 20px;
  margin-bottom: 10px;
`;

class ModalEdgeFixationCover extends React.PureComponent {
  constructor(props) {
    super(props);
    const { terminalBlockPreferences } = props;
    this.state = {
      applyToAll: false,
      selectedElectricalConnection: terminalBlockPreferences ? terminalBlockPreferences.electricalConnection : "",
      selectedCover: terminalBlockPreferences ? terminalBlockPreferences.cover : "",
      electricalConnectionOptions: props.electricalConnectionOptions || [],
      coverOptions: props.coverOptions || [],
    };
  }

  handleElectricalConnectionChange = (selectedOption) => {
    this.setState({ selectedElectricalConnection: selectedOption.value });
  };

  handleCoverChange = (selectedOption) => {
    this.setState({ selectedCover: selectedOption.value });
  };

  handleCheckboxChange = () => {
    this.setState({ applyToAll: !this.state.applyToAll });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.terminalBlockPreferences !== this.props.terminalBlockPreferences) {
      const { terminalBlockPreferences } = this.props;
      this.setState({
        selectedElectricalConnection: terminalBlockPreferences ? terminalBlockPreferences.electricalConnection : "",
        selectedCover: terminalBlockPreferences ? terminalBlockPreferences.cover : "",
      });
    }

    if (prevProps.electricalConnectionOptions !== this.props.electricalConnectionOptions) {
      this.setState({
        electricalConnectionOptions: this.props.electricalConnectionOptions || [],
      });
    }

    if (prevProps.coverOptions !== this.props.coverOptions) {
      this.setState({
        coverOptions: this.props.coverOptions || [],
      });
    }
  }



  render = () => {
    const { closeModal, isLoading } = this.props;

    const electricalConnectionOptions = [
      { id: "Spring", name: I10n.getOrDefault("connection_type.spring", "Spring", "data") },
      { id: "Screw", name: I10n.getOrDefault("connection_type.screw", "Screw", "data") },
    ];
    const coverOptions = [
      { id: "with cover", name: I10n.getOrDefault("connection_type.withcover", "with cover", "data") },
      { id: "without cover", name: I10n.getOrDefault("connection_type.withoutcover", "without cover", "data") },
    ];

    return (
      <Container>
        <Header>
          <Title>{I10n.get("connection_type.modal")}</Title>
          <CloseIcon
            href="#"
            onClick={(e) => {
              e.preventDefault();
              closeModal();
            }}
          >
            <MsxIcons name="modal-close"></MsxIcons>
          </CloseIcon>
        </Header>

        <SelectContainer>
          <DropdownContainer>
            <SectionTitle>{I10n.get("connection_type")}</SectionTitle>
            <ReactSelect
              value={{
                value: this.state.selectedElectricalConnection,
                label: I10n.getOrDefault(`connection_type.${this.state.selectedElectricalConnection.replaceAll(' ', '').toLowerCase()}`, this.state.selectedElectricalConnection, 'data'),
              }}
              name="electricalConnection"
              options={electricalConnectionOptions.map((option) => ({
                value: option.id,
                label: option.name,
              }))}
              onChange={this.handleElectricalConnectionChange}
              isDisabled={isLoading}
              isSearchable={false}
              menuPlacement="bottom"
            />
          </DropdownContainer>
          <DropdownContainer>
            <SectionTitle>{I10n.get("cover_type")}</SectionTitle>
            <ReactSelect
              value={{
                value: this.state.selectedCover,
                label: I10n.getOrDefault(`connection_type.${this.state.selectedCover.replaceAll(' ', '').toLowerCase()}`, this.state.selectedCover, 'data'),
              }}
              name="cover"
              options={coverOptions.map((option) => ({
                value: option.id,
                label: option.name,
              }))}
              onChange={this.handleCoverChange}
              isDisabled={isLoading}
              isSearchable={false}
              menuPlacement="bottom"
            />
          </DropdownContainer>
        </SelectContainer>
        <CheckboxContainer>
          <Checkbox
            onChange={this.handleCheckboxChange}
            checked={this.state.applyToAll}
            label={I10n.get("apply_to_all")}
          ></Checkbox>
        </CheckboxContainer>
        <ButtonContainer>
        <Button
          disabled={this.props.configurationSaver.isSaving}
          onClick={() => {
            const electricalConnection = this.state.selectedElectricalConnection;
            const cover = this.state.selectedCover;

            if (this.state.applyToAll) {
              this.props.massUpdateTerminalBlockSettings(
                this.props.configuration,
                electricalConnection,
                cover,
                this.state.applyToAll
              ).then(() => {
                this.props.getCompatibleModules(this.props.configuration.id);
                this.props.closeModal();
              });
            } else {
              this.props.updateTerminalBlockPreferences(
                this.props.configuration,
                electricalConnection,
                cover
              ).then(() => {
                this.props.getCompatibleModules(this.props.configuration.id);
                this.props.closeModal();
              });
            }
          }}
        >
          {I10n.get("app.action.ok")}
        </Button>

        </ButtonContainer>
      </Container>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    configuration: state.configuration,
    configurationSaver: state.configurationSaver,
    electricalConnectionOptions: state.electricalConnectionOptions,
    coverOptions: state.coverOptions,
    modalProps: state.modalProps,
    terminalBlockPreferences: state.configuration.terminalBlockPreferences,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    massUpdateTerminalBlockSettings: (
      configuration,
      electricalConnection,
      cover,
      applyToAll
    ) =>
      dispatch(
        massUpdateTerminalBlockSettings(
          configuration,
          electricalConnection,
          cover,
          applyToAll
        )
      ),
    updateTerminalBlockPreferences: (
      configuration,
      electricalConnection,
      cover,
      applyToAll
    ) =>
      dispatch(
        updateTerminalBlockPreferences(
          configuration,
          electricalConnection,
          cover,
          applyToAll
        )
      ),
    getCompatibleModules: (configurationID) => dispatch(getCompatibleModules(configurationID, {}, true, null)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalEdgeFixationCover);
